import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lastBackup: {},
  lastCustomerBackup: {},
  cohesityClusters: [],
  cohesityClustersByCustomer: [],
  cohesityClustersByType: [],
  activityLogsOfCustomer: [],
  htmlForBackupSupportPage: '',
  allCohesityAccounts: [],
  cohesityAccount: {},
  customerCohesityAccounts: [],
  createCohesityAccount: {},
  updateCohesityAccount: {},
  deleteCohesityAccount: {},
  usageReport: {},
  error: null,
};

const managedBackupSlice = createSlice({
  name: 'managedBackup',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setLastBackup: (state, action) => {
      state.lastBackup = action.payload;
      state.error = null;
    },
    setLastCustomerBackup: (state, action) => {
      state.lastCustomerBackup = action.payload;
      state.error = null;
    },
    setCohesityClusters: (state, action) => {
      state.cohesityClusters = action.payload;
      state.error = null;
    },
    setCohesityClustersByCustomer: (state, action) => {
      state.cohesityClustersByCustomer = action.payload;
      state.error = null;
    },
    setCohesityClustersByType: (state, action) => {
      state.cohesityClustersByType = action.payload;
      state.error = null;
    },
    setActivityLogsOfCustomer: (state, action) => {
      state.activityLogsOfCustomer = action.payload;
      state.error = null;
    },
    setHtmlForBackupSupportPage: (state, action) => {
      state.htmlForBackupSupportPage = action.payload;
      state.error = null;
    },
    setAllCohesityAccounts: (state, action) => {
      state.allCohesityAccounts = action.payload;
      state.error = null;
    },
    setCohesityAccount: (state, action) => {
      state.cohesityAccount = action.payload;
      state.error = null;
    },
    setUsageReport: (state, action) => {
      state.usageReport = action.payload;
      state.error = null;
    },
    setCustomerCohesityAccounts: (state, action) => {
      state.customerCohesityAccounts = action.payload;
      state.error = null;
    },
    setCreateCohesityAccount: (state, action) => {
      state.createCohesityAccount = action.payload;
      state.error = null;
    },
    setUpdateCohesityAccount: (state, action) => {
      state.updateCohesityAccount = action.payload;
      state.error = null;
    },
    setDeleteCohesityAccount: (state, action) => {
      state.deleteCohesityAccount = action.payload;
      state.error = null;
    },
    setResetManagedBackup: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setLastBackup,
  setLastCustomerBackup,
  setCohesityClusters,
  setCohesityClustersByCustomer,
  setCohesityClustersByType,
  setActivityLogsOfCustomer,
  setHtmlForBackupSupportPage,
  setAllCohesityAccounts,
  setCohesityAccount,
  setUsageReport,
  setCustomerCohesityAccounts,
  setCreateCohesityAccount,
  setUpdateCohesityAccount,
  setDeleteCohesityAccount,
  setResetManagedBackup,
} = managedBackupSlice.actions;

export default managedBackupSlice.reducer;
